import { apiClient } from "../config";

async function formNameValidation(data: any) {
  const res = await apiClient.post(`/admin/dynamic-forms/name-validation`,data);
  return res.data;
}

export default formNameValidation;
